import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CopyPasteSvg = function CopyPasteSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.77 2.249h6.922v.93h2.77v4.884h-1.385V4.575h-1.385v1.86H5.77v-1.86H4.385v11.628h4.384v1.395H3V3.179h2.77zm1.384 1.395V5.04h4.154V3.644z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 14.807h-3.23v-1.395H18zM13.385 18.528H18v-1.395h-4.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 9.69H10.385V22.25H21zm-9.23 11.164v-9.768h7.845v9.768z",
    clipRule: "evenodd"
  }));
};
export var CopyPaste = function CopyPaste(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CopyPasteSvg
  }));
};